// DEPRECATED DO NOT CHANGE
import { TConfig } from '@@/auto/interfaces';

const ToggleConfig: DeepPartial<TConfig> = {};
export default ToggleConfig;
